var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c3.86 0 7 3.14 7 7a7.007 7.007 0 01-7 7.001c-3.86 0-7-3.14-7-7.001 0-3.86 3.14-7 7-7zm0 1.458A5.548 5.548 0 002.458 8 5.548 5.548 0 008 13.543 5.548 5.548 0 0013.542 8 5.548 5.548 0 008 2.458zM8 6.39c.369 0 .674.247.722.567l.007.09v4.217c0 .363-.327.656-.729.656-.369 0-.674-.246-.722-.567l-.007-.089V7.047c0-.362.327-.656.729-.656zm-.28-2.253a.71.71 0 01.563 0 .754.754 0 01.233.156.769.769 0 01.214.515.769.769 0 01-.214.515.754.754 0 01-.515.214.73.73 0 01-.729-.729.73.73 0 01.058-.282.627.627 0 01.155-.233.77.77 0 01.234-.156z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/InfoCircle.dff296bf.svg";
export { ForwardRef as ReactComponent };